import React from "react";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { Close, GppMaybeOutlined } from "@mui/icons-material";
import PushNotificationOptIn from "../account/PushNotificationOptIn";
import { colors } from "../../theme/colors";

export default function AccountStatusNoticeInfoPanel({
  notice,
  onClose,
  user,
  accountPath = "/account",
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        width: { xs: "calc(100vw - 2rem)", sm: 420 },
        maxWidth: "100%",
        p: "1rem",
        textAlign: "left",
        borderRadius: "18px",
        backgroundColor: colors.background.base,
        border: `1px solid ${colors.border.subtle}`,
        boxShadow: "0 12px 24px rgba(0,0,0,0.35)",
        pointerEvents: "auto",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <GppMaybeOutlined
              sx={(theme) => ({
                fontSize: "1.35rem",
                color: theme.palette.info.main,
              })}
            />
            <Typography variant="subtitle2" sx={{ color: colors.text.primary, fontWeight: 700 }}>
              {notice.title}
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: colors.text.secondary, mt: 0.5 }}>
            {notice.body}
          </Typography>
          {notice.subMessage ? (
            <Typography
              variant="caption"
              sx={{ display: "block", color: colors.text.muted, mt: 0.35, fontSize: "0.75rem" }}
            >
              {notice.subMessage}
            </Typography>
          ) : null}
          {(notice.showPushOptIn || notice.ctaLabel) ? (
            <Box sx={{ mt: 1.25, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
              {notice.showPushOptIn ? (
                <PushNotificationOptIn user={user} compact buttonOnly />
              ) : null}
              {notice.ctaLabel ? (
              <Button
                component={Link}
                to={accountPath}
                variant="contained"
                color={notice.severity || "info"}
                size="small"
                sx={{ borderRadius: "14px" }}
              >
                {notice.ctaLabel}
              </Button>
              ) : null}
            </Box>
          ) : null}
        </Box>
        <IconButton
          size="small"
          aria-label="Close profile review notice"
          onClick={onClose}
          sx={{ color: colors.text.secondary, mt: -0.25, mr: -0.25 }}
        >
          <Close fontSize="small" />
        </IconButton>
      </Box>
    </Paper>
  );
}
